import axiosInstance from './axios.instance';

const connectionService = {
  followUser: async (userId) => {
    const response = await axiosInstance.post(`/connections/follow/${userId}`);
    return response.data;
  },

  unfollowUser: async (userId) => {
    const response = await axiosInstance.delete(`/connections/follow/${userId}`);
    return response.data;
  },

  sendConnectionRequest: async (userId, message = '') => {
    const response = await axiosInstance.post(`/connections/connect/${userId}`, { message });
    return response.data;
  },

  acceptConnectionRequest: async (connectionId) => {
    const response = await axiosInstance.put(`/connections/connect/${connectionId}/accept`);
    return response.data;
  },

  rejectConnectionRequest: async (connectionId) => {
    const response = await axiosInstance.put(`/connections/connect/${connectionId}/reject`);
    return response.data;
  },

  removeConnection: async (userId) => {
    const response = await axiosInstance.delete(`/connections/connect/${userId}`);
    return response.data;
  },

  getMyConnections: async (page = 1, limit = 20) => {
    const response = await axiosInstance.get('/connections/connections', {
      params: { page, limit }
    });
    return response.data;
  },

  getPendingConnectionRequests: async () => {
    const response = await axiosInstance.get('/connections/requests/pending');
    return response.data;
  },

  getAllConnectionRequests: async () => {
    const response = await axiosInstance.get('/connections/requests/all');
    return response.data;
  },

  getMyFollowers: async (page = 1, limit = 20) => {
    const response = await axiosInstance.get('/connections/followers', {
      params: { page, limit }
    });
    return response.data;
  },

  getMyFollowing: async (page = 1, limit = 20) => {
    const response = await axiosInstance.get('/connections/following', {
      params: { page, limit }
    });
    return response.data;
  },

  getConnectionStatus: async (userId) => {
    const response = await axiosInstance.get(`/connections/status/${userId}`);
    return response.data;
  },

  getUserStats: async (userId) => {
    const response = await axiosInstance.get(`/connections/stats/${userId}`);
    return response.data;
  }
};

export default connectionService;
